/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-16 12:30:22
 * @FilePath: /unifyxp-v2-store-portal/src/layout/SalesChannelEditorLayout/SalesChannelEditorLayout.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';
import { useSelector } from 'react-redux';
import css from './css.less';
import { menuArray } from '@/src/config/SiderConfig/SalesChannelEditorContentSiderConfig';
import { PageStructure, Trigger } from 'src/layout/Components';
import {
  // useQueryLanguageListContentEditor,
  // // EnumAction,
  EnumMultiLanguageType,
} from 'src/constrains/SalesChannelMultiLanguageSelect';
import {
  useFetchSalesChannel,

  // useClearSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';
import { useSalesChannel } from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { Spin } from 'antd';
import { siderWidth } from 'src/tools/constant';
import { useSalesChannelEditorWs } from 'src/hooks/useSalesChannelEditorWs';

const SalesChannelEditorWsContext = React.createContext(null);
const Provider = (props) => {
  const { children } = props;
  const {
    onContentClick: handleOnContentClick,
    pageEditors,
    isConnected,
    isClicked,
    isOtherEditing,
    isClosed,
    onEdit,
  } = useSalesChannelEditorWs();
  return (
    <SalesChannelEditorWsContext.Provider
      value={{
        onContentClick: handleOnContentClick,
        pageEditors,
        isConnected,
        isClicked,
        isOtherEditing,
        isClosed,
        onEdit,
      }}>
      {children}
    </SalesChannelEditorWsContext.Provider>
  );
};

const SalesChannelEditorLayout = (props) => {
  //const { __isCurrentSalesChannel: isCurrent } = props;
  const {
    onContentClick,
    isOtherEditing,
    isConnected,
    isClicked,
    // isClosed,
    onEdit,
    displaySpin,
  } = React.useContext(SalesChannelEditorWsContext);

  const collapse = useSelector(
    (state: any) => state.mainLayout.isSiderCollapsed,
  );

  const extraHeaderHeight = 80;
  const { isCurrentSalesChannel } = useFetchSalesChannel({
    forceUpdate: true,
    uuidKey: 'saleChannelUuid',
  });
  const { isCurrent } = useSalesChannel({
    type: EnumMultiLanguageType.SalesChannelContent,
    saleChannelUuidKey: 'saleChannelUuid',
    isStyleRequired: true,
  });

  React.useEffect(() => {
    return () => {
      //useClearSalesChannel();
    };
  }, []);
  const styleGenerator = (z): any => {
    return {
      width: `calc(100% - ${siderWidth}px)`,
      height: 'calc(100% - 168px)',
      position: 'fixed',
      zIndex: z,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      // background: 'rgba(0,0,0,0.05)',
    };
  };
  return (
    <PageStructure
      onContentClick={onEdit}
      trigger={<Trigger open={!collapse} />}
      menuArray={isCurrent ? menuArray : null}
      siderClassName={css.trigger}
      extraHeader={{ extraHeaderHeight: isCurrent ? extraHeaderHeight : 0 }}>
      {displaySpin && <Spin style={styleGenerator(9)} spinning={true}></Spin>}
      {!isClicked && isOtherEditing && isConnected && (
        <div onClick={onContentClick} style={styleGenerator(1)} />
      )}
      {/* 遮罩层 */}

      {isCurrent && isCurrentSalesChannel && props.children}
    </PageStructure>
  );
};

const _SalesChannelEditorLayout = (props) => {
  return (
    <Provider>
      <SalesChannelEditorLayout {...props} />
    </Provider>
  );
};

export default _SalesChannelEditorLayout;
export { SalesChannelEditorWsContext };
